export class GroupType {
    group_type_id?: number;
    ordinal: number;
    group_type: string;
    group_type_desc: string;
    use_system_global_intervals: boolean;

    constructor(id: number, ordinal: number, group_type: string, group_type_desc: string, use_system_global_intervals: boolean) {
        this.group_type_id = id;
        this.ordinal = ordinal;
        this.group_type = group_type;
        this.group_type_desc = group_type_desc;
        this.use_system_global_intervals = use_system_global_intervals;
    }
}
